import React from "react";
import { Routes, Route } from "react-router-dom";
import MainDashboard from "@modules/mainDashboard";
import LoginPage from "@modules/login";
import StepperComponent from "@modules/stepper";
import VerifyDetails from "@modules/login/components/verifyDetails";
import { ApplicationDetails } from "@modules/application-section/application-details";
import { ApplicationPreview } from "@modules/application-section/application-preview";
import Signup from "@modules/signup";
import { ApplicationDashboard } from "@modules/application-section/application-dashboard";
import Register from "@modules/register";
import StepperComponentROW from "@modules/stepper-row";
import { ApplicationPreviewDetailsROW } from "@modules/application-section-row/application-details";
import { ApplicationDetailsROW } from "@modules/application-section-row/application-details-row";
import { ApplicationSuccess } from "@modules/application-success";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import { LicenseFee } from "@modules/provisional-payment/license/LicenseFee";
import { ProvisionalPayment } from "@modules/provisional-payment/index";
import VerifyGST from "@modules/register/components/VerifyGST";
import ApplicationFailed from "@modules/application-failed";
import ViewProfile from "@modules/profile/ViewProfile";
import { BgReupload } from "@modules/application-section-row/application-details-row/BgReupload";
import { HelpDesk } from "@modules/helpdesk";
import TicketDetail from "@modules/helpdesk/ticket-detail";
import FinalLicenseFee from "@modules/provisional-payment/license/FinalLicenseFee";
import { PaymentSucces } from "@modules/payment-success";
import { FAQ } from "@modules/faq";
import RegistrationSuccessful from "@modules/register/components/registrationSuccessful";
import DocListAccessPermission from "@modules/public-comments/components/docListAccessPermission";
import DocListRightofWayPermission from "@modules/public-comments/components/docListRightofWayPermission";
import PublicComments from "@modules/public-comments/components/publicComments";
// import ProdFileUpload from "@modules/fileupload";
import ErrorPageNotFound from "@modules/ErrorPageNotFound";
import Guidelines from "@modules/public-comments/components/guidelines";
import PrivacyPolicy from "@modules/privacy-policy";
import Notifications from "@modules/public-comments/components/Notifications";
import Redirect from "@modules/redirect";
import ApplicationRenewal from "@modules/application-renewal";
import App from "src/App";
import PaymentSection from "@modules/stepper/components/PaymentNew";
import RenewalPayment from "@modules/application-renewal/components/RenewalPayment";
import { EsignFailed } from "@modules/esign-failed";
import LegacyApplicationUpdate from "@modules/legacy-application-update";
import OrganisationForm from "@modules/organisation/components/organisationForm";
import { SpocMembers } from "@modules/spocmembers";
import { DetailsMember } from "@modules/spocmembers/detailsMember";
import { EditDetailsMember } from "@modules/spocmembers/editDetailsMember";
import UpdateDocumentsPage from "@modules/update-documents/index";
// import UpdateQuestionPage from "@modules/update-question"; 
import ClarificationQuestionsPage from "@modules/update-question";
import ProdFileUpload from "@modules/fileupload";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/" element={<LoginPage />} />
        <Route path="/organisation" element={<OrganisationForm />} />

        <Route path="/public-comments" element={<PublicComments />} />

        <Route path="/guidelines" element={<Guidelines />} />
        <Route path="/notifications" element={<Notifications />} />

        <Route path="/signup" element={<Signup />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-gst" element={<VerifyGST />} />
        <Route path="/faqs" element={<FAQ />} />
        <Route
          path="/access-permission"
          element={<DocListAccessPermission />}
        />
        <Route
          path="/right-of-way-permission"
          element={<DocListRightofWayPermission />}
        />
        <Route
          path="/registration-successful"
          element={<RegistrationSuccessful />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/redirect" element={<Redirect />} />
      </Route>
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<MainDashboard />} />
        <Route path="/stepper" element={<StepperComponent />} />
        <Route path="/update-documents" element={<UpdateDocumentsPage />} />
        <Route path="/update-questions" element={<ClarificationQuestionsPage />} />
        <Route path="/stepper-row" element={<StepperComponentROW />} />
        <Route path="/application-details" element={<ApplicationDetails />} />
        <Route path="/verifyDetails" element={<VerifyDetails />} />
        <Route path="/application-preview" element={<ApplicationPreview />} />
        <Route path="/view-profile" element={<ViewProfile />} />
        <Route path="/help-desk" element={<HelpDesk />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/file-upload" element={<ProdFileUpload />} />
        <Route
          path="/application-dashboard/public-comments"
          element={<PublicComments />}
        />

        <Route
          path="/application-dashboard/guidelines"
          element={<Guidelines />}
        />

        <Route
          path="/application-dashboard/access-permission"
          element={<DocListAccessPermission />}
        />
        <Route
          path="/application-dashboard/right-of-way-permission"
          element={<DocListRightofWayPermission />}
        />
        <Route path="/org-admin/spoc-members" element={<SpocMembers />} />
        <Route
          path="/org-admin/spoc-members/edit/:id"
          element={<EditDetailsMember />}
        />

        <Route
          path="/org-admin/spoc-members/details/:id"
          element={<DetailsMember />}
        />

        <Route path="/ticket-detail/:id" element={<TicketDetail />} />
        <Route
          path="/application-dashboard"
          element={<ApplicationDashboard />}
        />
        <Route
          path="/application-preview-details-row"
          element={<ApplicationPreviewDetailsROW />}
        />
        <Route
          path="/application-details-row"
          element={<ApplicationDetailsROW />}
        />
        <Route path="/application-submitted" element={<ApplicationSuccess />} />
        <Route path="/application-failed" element={<ApplicationFailed />} />
        <Route path="/payment-success" element={<PaymentSucces />} />
        <Route path="/esign" element={<ProvisionalPayment />} />
        <Route path="/apply-renewal" element={<ApplicationRenewal />} />
        <Route
          path="/renewal-payment"
          element={<RenewalPayment isProcessing={false} />}
        />
        <Route path="/payment" element={<LicenseFee />} />
        <Route path="/final-license-fee" element={<FinalLicenseFee />} />
        <Route path="/bg-reupload" element={<BgReupload />} />
        <Route path="/esign-failed" element={<EsignFailed />} />
        <Route
          path="/legacy-application"
          element={<LegacyApplicationUpdate />}
        />
      </Route>
      <Route path="*" element={<ErrorPageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;
